var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIAlramOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1048 14.7617C17.8967 14.5063 17.7832 14.1942 17.7643 13.8631L17.6035 9.30432C17.5089 6.53309 15.4943 4.12127 12.742 3.76186C9.39385 3.32678 6.49966 5.86156 6.38616 9.12462L6.21592 13.8726C6.20646 14.2036 6.0835 14.5157 5.87542 14.7711L4.5702 16.3695C4.20133 16.8141 4.52291 17.4951 5.09986 17.4951H9.35601C9.35601 18.9138 10.5572 20.1244 11.9854 20.1244C13.4135 20.1244 14.6147 18.9232 14.6147 17.4951H18.8709C19.4478 17.4951 19.7694 16.8235 19.4005 16.3695L18.0953 14.7711L18.1048 14.7617Z",
    fill: "#FFBF3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78794 9.76735C5.16627 9.76735 5.47839 9.46469 5.4973 9.08636C5.54459 7.64873 6.05533 6.29621 6.96331 5.18961C7.20923 4.88695 7.17139 4.44242 6.86873 4.18705C6.56607 3.94114 6.12154 3.97897 5.86617 4.28163C4.75957 5.63414 4.14479 7.27986 4.07858 9.02961C4.06913 9.4174 4.37179 9.74843 4.75957 9.76735C4.75957 9.76735 4.77849 9.76735 4.78794 9.76735Z",
    fill: "#FFBF3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0481 4.28244C17.8022 3.97978 17.3482 3.93249 17.0456 4.18786C16.7429 4.43377 16.6956 4.88776 16.951 5.19042C17.9063 6.34432 18.4548 7.80087 18.5021 9.27633C18.5116 9.65466 18.8332 9.95732 19.2115 9.95732C19.2115 9.95732 19.2304 9.95732 19.2399 9.95732C19.6276 9.94786 19.9398 9.61683 19.9208 9.21959C19.8546 7.432 19.1926 5.68225 18.0481 4.28244Z",
    fill: "#FFBF3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIAlramOn);
export default __webpack_public_path__ + "static/media/i_alram_on.e573fdc0598c27e9b5bec89ab708e8f1.svg";
export { ForwardRef as ReactComponent };